import React,{Component} from 'react';
import customSpinner from './customSpinner.gif';
//import Spiining from './Spiining.gif';

import "./spinner.css";

export class Spinner extends Component{
    render(){
        return(
            <div className={"loader-wrapper"}>
                <img src={customSpinner} style={{width:60 ,height:60}}alt="loading"/>
            </div>
        
        )

    }
}

export default Spinner